module.exports = __webpack_public_path__ + "static/media/25UNHCR3.8c1f65d7.jpg";